"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentStatusBadge = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const polaris_1 = require("@shopify/polaris");
const lodash_1 = require("lodash");
const StyledBadge = styled_components_1.default.span `
  .Polaris-Text--bodySm {
    font-weight: 600;
  }
`;
const ShipmentStatusBadge = ({ statusCode, orderStatus = null }) => {
    const status = statusCode || orderStatus || '';
    const isError = status.includes('error');
    const tone = !statusCode || isError ? 'critical' : 'new';
    if (status) {
        return (react_1.default.createElement(StyledBadge, null,
            react_1.default.createElement(polaris_1.Badge, { tone: tone }, (0, lodash_1.startCase)(status))));
    }
    return react_1.default.createElement("span", null, "\u00A0");
};
exports.ShipmentStatusBadge = ShipmentStatusBadge;
